export const MAX_OPTIONS_DESKTOP = 8 // 3 cols x 3 options - 1 for see more
export const MAX_OPTIONS_TABLET = 5 // 2 cols x 3 options - 1 for see more
export const MAX_OPTIONS_MOBILE = 5 //
